'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cartIntentOOI = require('./cartIntentOOI');

var _cartIntentOOI2 = _interopRequireDefault(_cartIntentOOI);

var _providerEvents = require('wix-art-store-3rd-party/dist/src/sdk/providerEvents');

var _providerEvents2 = _interopRequireDefault(_providerEvents);

var _checkoutIntentOOI = require('../checkout/checkoutIntentOOI');

var _checkoutIntentOOI2 = _interopRequireDefault(_checkoutIntentOOI);

var _ProviderModalOOI = require('./ProviderModalOOI');

var _ProviderModalOOI2 = _interopRequireDefault(_ProviderModalOOI);

var _consts = require('../consts');

var _checkoutHandler = require('./checkoutHandler');

var _checkoutHandler2 = _interopRequireDefault(_checkoutHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageManager = function (_Component) {
  (0, _inherits3.default)(PageManager, _Component);

  function PageManager(props) {
    (0, _classCallCheck3.default)(this, PageManager);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PageManager.__proto__ || (0, _getPrototypeOf2.default)(PageManager)).call(this, props));

    _this.state = {
      pagesData: {
        isMobile: props.isMobile,
        viewMode: props.viewMode,
        connectedProviders: props.connectedProviders,
        locale: props.locale,
        deviceType: props.deviceType
      }
    };
    _this.checkoutHandler = new _checkoutHandler2.default(props.baseUrl);

    _this.setShopEditorData = _this.setShopEditorData.bind(_this);
    _this.goToCheckout = _this.goToCheckout.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(PageManager, [{
    key: 'setShopEditorData',
    value: function setShopEditorData(data) {
      this.shopEditorData = data;
    }
  }, {
    key: 'goToCheckout',
    value: function goToCheckout() {
      if (this.cartIntent) {
        this.cartIntent.postMessage(_providerEvents2.default.checkout, {});
      }
    }
  }, {
    key: 'updateCartItemsIfNeeded',
    value: function updateCartItemsIfNeeded(cartItems) {
      if (this.shouldUpdateCartItems && this.cartIntent) {
        this.cartIntent.postMessage(_providerEvents2.default.refreshCart, cartItems);
        this.shouldUpdateCartItems = false;
      }
    }
  }, {
    key: 'getCartPage',
    value: function getCartPage(data) {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'artstore-cart-element', style: {
            visibility: data.showCart ? 'visible' : 'hidden'
          } },
        _react2.default.createElement(_cartIntentOOI2.default, {
          isMobile: data.isMobile,
          viewMode: data.viewMode,
          wixSdk: data.wixSdk,
          connectedProviders: data.connectedProviders,
          count: data.cartItemsCount,
          additionalProviderParams: data.additionalProviderParams,
          visible: data.showCart,
          closeCart: function closeCart() {
            return data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.CART, false);
          },
          onGoToCheckout: function onGoToCheckout(checkoutParams) {
            return _this2.checkoutHandler.handleCheckoutRequest(data, checkoutParams);
          },
          locale: data.locale,
          toggleShopEditorPage: function toggleShopEditorPage(editorData) {
            _this2.setShopEditorData(editorData);
            data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.EDITOR, true);
          },
          artStoreApi: data.storeApi,
          cartItems: data.cartItems,
          deviceType: data.deviceType,
          setCartIntent: function setCartIntent(cartIntent) {
            return _this2.cartIntent = cartIntent;
          }
        })
      );
    }
  }, {
    key: 'getShopEditorPage',
    value: function getShopEditorPage(data) {
      var _this3 = this;

      var _shopEditorData = this.shopEditorData,
          urlPath = _shopEditorData.urlPath,
          urlParams = _shopEditorData.urlParams,
          name = _shopEditorData.name,
          item = _shopEditorData.item,
          isDemo = _shopEditorData.isDemo,
          itemUrl = _shopEditorData.itemUrl,
          galleryId = _shopEditorData.galleryId;

      var isDemoItem = isDemo === undefined ? 'false' : isDemo;
      return _react2.default.createElement(
        'div',
        { className: 'artstore-shop-editor-element' },
        _react2.default.createElement(_ProviderModalOOI2.default, {
          name: name,
          urlParams: urlParams,
          urlPath: urlPath,
          wixSdk: data.wixSdk,
          additionalProviderParams: data.additionalProviderParams,
          onClose: function onClose() {
            return data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.EDITOR, false);
          },
          onUpdateCartItems: function onUpdateCartItems() {
            return _this3.shouldUpdateCartItems = true;
          },
          connectedProviders: data.connectedProviders,
          artStoreApi: data.storeApi,
          cartItems: data.cartItems,
          galleryId: galleryId,
          additionalParams: {
            galleryId: galleryId,
            isDemo: isDemoItem,
            itemUrl: itemUrl || item.url
          }
        })
      );
    }
  }, {
    key: 'getCheckoutPage',
    value: function getCheckoutPage(data) {
      return _react2.default.createElement(
        'div',
        { className: 'artstore-checkout-element' },
        _react2.default.createElement(_checkoutIntentOOI2.default, {
          wixSdk: data.wixSdk,
          artStoreApi: data.storeApi,
          onClose: function onClose(openCart) {
            data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.CHECKOUT, false);
            if (openCart) {
              data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.CART, true);
            }
          },
          cartItems: data.cartItems,
          additionalProviderParams: data.additionalProviderParams,
          connectedProviders: data.connectedProviders,
          locale: data.locale,
          deviceType: data.deviceType,
          viewMode: data.viewMode,
          styleParams: {},
          checkoutParams: this.checkoutHandler.getCheckoutData()
        })
      );
    }
  }, {
    key: 'getPages',
    value: function getPages(_data, _ref, widgetType) {
      var showCart = _ref.showCart,
          showCheckout = _ref.showCheckout,
          showShopEditor = _ref.showShopEditor,
          showStorePopupMessage = _ref.showStorePopupMessage;

      var commonProps = (0, _extends3.default)({}, this.state.pagesData, {
        cartItemsCount: _data.cartItemsCount,
        cartItems: _data.cartItems,
        wixSdk: _data.wixSdk,
        storeApi: _data.storeApi,
        additionalProviderParams: _data.additionalProviderParams,
        changeStoreFrameState: _data.changeStoreFrameState
      });
      this.updateCartItemsIfNeeded(_data.cartItems);
      var dom = [this.getCartPage((0, _extends3.default)({}, commonProps, { showCart: showCart }))];
      if (showCheckout) {
        dom.push(this.getCheckoutPage(commonProps));
      }
      if (showShopEditor) {
        dom.push(this.getShopEditorPage(commonProps));
      }
      if (showStorePopupMessage) {
        dom.push(this.checkoutHandler.getCheckoutPopupMessage(commonProps));
      }
      return _react2.default.createElement(
        'div',
        { className: 'artstore-fullscreen-frames' },
        dom
      );
    }
  }]);
  return PageManager;
}(_react.Component);

exports.default = PageManager;